import React, {Component} from 'react';



export default class Selection extends Component {
  render() {
    const {selected, options, onSelect, theme_colors } = this.props;

    return (
      <div className={"selection"}>
        {options.map(u => <span key={u['key']} className="selection" style={{marginRight: '12px', color: theme_colors.text}}>
          <input key={u['key']} type="radio" value={u['key']} checked={selected === u['key']} onChange={onSelect} />
          {u['text']}
        </span>)}
      </div>
    );
  }
}
